var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentContractManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6 15.2L14.2 12.9L14.6 12H13.2L13.6 12.9L13.1 15.2L12.2 11.9L9.90001 12.8C9.70001 13.2 9.20001 16.6 9.20001 16.6C10.7 16.9 12.3 17.1 13.9 17.1C15.5 17.1 17 17 18.6 16.6C18.6 16.6 18.1 13.3 17.9 12.8L15.6 11.9L14.6 15.2Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3 6.20001C12.1 6.20001 11.9 6.30001 11.8 6.50001V6.60001C11.8 7.00001 11.8 7.50001 11.8 7.90001C11.5 8.00001 11.3 8.20001 11.5 8.80001C11.6 9.20001 11.8 9.50001 12.1 9.50001C12.4 10.4 12.9 11 13.8 11C14.7 11 15.2 10.4 15.5 9.50001C15.8 9.50001 15.9 9.20001 16.1 8.80001C16.3 8.20001 16.1 8.00001 15.8 7.90001C15.9 7.50001 15.8 7.00001 15.7 6.60001C15.7 6.40001 15.5 6.30001 15.3 6.30001C15 5.90001 14.5 5.60001 14 5.60001C12.4 5.10001 12.3 6.20001 12.3 6.20001Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1 17.6V18.3H1.4V1.3H10.5V3.7C10.5 3.9 10.8 4 10.8 4H13.2V4.9C13.7 4.9 14.1 4.9 14.5 5.2V2.9L11.4 0H0.5C0.2 0 0 0.2 0 0.5V19C0.1 19.3 0.2 19.5 0.5 19.6H14.2C14.4 19.5 14.6 19.3 14.6 19.1V17.5L13.1 17.6Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69998 9.59999V9.19999L8.79998 8.99999L8.39998 7.89999L8.79998 6.99999L8.49998 6.69999L7.59998 7.29999L6.49998 6.69999L6.29998 5.79999H5.89998L5.79998 6.69999L4.39998 7.09999L3.89998 6.69999L3.39998 7.09999L3.79998 7.69999L3.29998 9.19999L2.59998 9.29999V9.69999L3.49998 9.79999L3.89998 11L3.49998 11.7L3.79998 12L4.49998 11.6L5.69998 12.2L5.99998 13.1H6.39998L6.49998 12.2L7.79998 11.6L8.49998 12L8.79998 11.7L8.39998 10.8L8.79998 9.59999H9.69998ZM5.99998 11.2C4.99998 11.2 4.29998 10.4 4.29998 9.49999C4.29998 8.49999 5.09998 7.79999 5.99998 7.79999C6.89998 7.79999 7.69998 8.59999 7.69998 9.49999C7.79998 10.4 6.99998 11.2 5.99998 11.2Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99998 10.4C6.49703 10.4 6.89998 9.99706 6.89998 9.50001C6.89998 9.00295 6.49703 8.60001 5.99998 8.60001C5.50292 8.60001 5.09998 9.00295 5.09998 9.50001C5.09998 9.99706 5.50292 10.4 5.99998 10.4Z",
    fill: "#60605F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5,
    height: 19.7,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentContractManagement);
export default __webpack_public_path__ + "static/media/Student_Contract _Management.0882be6e5952ee69dda93ab8add590a7.svg";
export { ForwardRef as ReactComponent };